import { RouteObject } from 'react-router-dom'

import PrivateRoute from 'component/common/private-route'
import { FEATURE } from 'constants/feature'
import PTOStakingNFTs from 'modules/stake-nft/listing-pto'
import StakingNftTransactions from 'modules/stake-nft/transaction'
import Staking from 'pages/staking'
import PoolDetail from 'pages/staking/pool-detail'
import StakingNFT from 'pages/staking-nft'
import StakingToken from 'pages/staking-token'
import StakingTokenDetail from 'pages/staking-token/detail'
import StakingErc3643Page from 'pages/staking-erc-3643'
import StakingErc3643PoolDetail from 'pages/staking-erc-3643/pool-detail'
import { PAGES } from 'routes/index'

export const stakingRoutes: RouteObject[] = [
  {
    path: PAGES.STAKING,
    element: (
      <PrivateRoute feature={FEATURE.STAKING_POOL}>
        <Staking />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.STAKING_DETAIL,
    element: (
      <PrivateRoute feature={FEATURE.STAKING_POOL}>
        <PoolDetail />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.STAKING_NFT,
    element: (
      <PrivateRoute feature={FEATURE.STAKING_NFT}>
        <StakingNFT />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.STAKING_NFT_PTO,
    element: (
      <PrivateRoute feature={FEATURE.STAKING_NFT}>
        <PTOStakingNFTs />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.STAKING_NFT_TRANSACTION,
    element: (
      <PrivateRoute feature={FEATURE.STAKING_NFT}>
        <StakingNftTransactions />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.STAKING_ERC3643,
    element: (
      <PrivateRoute feature={FEATURE.STAKING_NFT}>
        <StakingErc3643Page />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.STAKING_ERC3643_POOL_DETAIL,
    element: (
      <PrivateRoute feature={FEATURE.STAKING_NFT}>
        <StakingErc3643PoolDetail />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.STAKING_TOKEN,
    element: (
      <PrivateRoute feature={FEATURE.STAKING_TOKEN}>
        <StakingToken />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.STAKING_TOKEN_DETAIL,
    element: (
      <PrivateRoute feature={FEATURE.STAKING_TOKEN}>
        <StakingTokenDetail />
      </PrivateRoute>
    ),
  },
]
